import {
  Dialog,
  SubmissionForm,
  TextInputField,
  IDialogProps
} from "@bps/fluent-ui";
import { HttpError } from "@bps/http-client";

export interface CommsSmsTestingSendFormValues {
  tenantId: string;
  phoneNumber: string;
  message: string;
}

interface ICommsSmsTestingSendDialogProps extends IDialogProps {
  onSubmit: (values: CommsSmsTestingSendFormValues) => Promise<void>;
  onDismiss: () => void;
  error: HttpError | null;
}

export const CommsSmsTestingSendDialog: React.FC<ICommsSmsTestingSendDialogProps> = ({
  onSubmit,
  onDismiss,
  error,
  ...props
}) => {
  const handleSubmit = async (values: CommsSmsTestingSendFormValues) => {
    return await onSubmit(values);
  };

  return (
    <Dialog
      {...props}
      onDismiss={onDismiss}
      dialogContentProps={{
        showCloseButton: true,
        title: "Send SMS"
      }}
    >
      <SubmissionForm<CommsSmsTestingSendFormValues>
        initialValues={{
          tenantId: "",
          phoneNumber: "+614",
          message: "Ops console testing message"
        }}
        cancelButtonProps={{ onClick: onDismiss }}
        submitButtonProps={{ title: "Send", alwaysEnabled: true }}
        onSubmit={handleSubmit}
      >
        {() => {
          return (
            <>
              <TextInputField name="tenantId" label="Tenant ID" required />
              <TextInputField
                name="phoneNumber"
                label="Phone number"
                required
              />
              <TextInputField
                name="message"
                label="Message"
                multiline
                rows={3}
                required
              />
            </>
          );
        }}
      </SubmissionForm>
    </Dialog>
  );
};
